import './App.css';
import Chat from "./chat/ChatInput";
import React from "react";
import ChatHistory from "./chat/ChatHistory";

function App() {
    return (
        <div className="App">
            <div className="top-splash">
            <span className="app-heading bold">LLM</span><span className="app-heading">ARCHITECT</span>
            </div>
            <div className="App-header">
                <Chat/>
            </div>
        </div>

    );
}

export default App;
